import { render, staticRenderFns } from "./pinOrange.vue?vue&type=template&id=270b240a&scoped=true"
import script from "./pinOrange.vue?vue&type=script&lang=js"
export * from "./pinOrange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b240a",
  null
  
)

export default component.exports